<template>
  <div class="admin-container">
    <div class="admin-header">
      <h1>SFI Analytics</h1>
    </div>
    <FilterComponent />
    <FetchData />
    <div v-if="sfiStore.loading" class="loading-state">Getting the data...</div>
    <div v-else-if="sfiStore.error" class="error-state">
      Error: {{ sfiStore.error }}
    </div>
    <div v-else>
      <KPICards />
      <AreaChartSFIComponent />
      <TotalAssignedDataComponent />
      <MostPopularSP />
      <EducatorData />
    </div>
  </div>
</template>

<script setup>
import AreaChartSFIComponent from "@/components/admin/sfi/AreaChartSFIComponent.vue";
import KPICards from "@/components/admin/sfi/KPICards.vue";
import TotalAssignedDataComponent from "@/components/admin/sfi/TotalAssignedDataComponent.vue";
import { sfiStore } from "@/services/sfiService";
import FetchData from "@/components/admin/sfi/FetchData.vue";
import FilterComponent from "@/components/admin/sfi/FilterComponent.vue";
import MostPopularSP from "@/components/admin/sfi/MostPopularSP.vue";
import EducatorData from "@/components/admin/sfi/EducatorData.vue";
</script>
